module.exports = __webpack_public_path__ + "static/media/howItWork3.d34f2c13.png";